import React from 'react';
import CarouselArrows from './components/CarouselArrows';
import ItemsList from './components/ItemsList';
import { Container, StyledCarousel } from './ContentItemCarousel.styles';

export const CARD_TYPE = {
    CONTENT_ITEM: 'CONTENT_ITEM',
    SHOWCASE: 'SHOWCASE',
    PROMOTION: 'PROMOTION',
};

const ContentItemCarousel = (props) => {
    const { id, presentation, cardType, className, dataRt } = props;

    return (
        <Container className={className} data-rt={dataRt}>
            <>
                <CarouselArrows carouselId={id} presentation={presentation} cardType={cardType} />
                <div
                    style={{
                        overflow: 'hidden',
                        position: 'relative',
                    }}
                >
                    <StyledCarousel id={`core-carousel-${id}`} friction={0.8}>
                        <ItemsList {...props} />
                    </StyledCarousel>
                </div>
            </>
        </Container>
    );
};

export default ContentItemCarousel;
